import { jsx as e, jsxs as n } from "react/jsx-runtime";
import { T as t } from "../Table-Cj-wDn-T.js";
import { u as _ } from "../Accordion-BylYhoFN.js";
import { c as r } from "../clsx-OuTLNxxd.js";
import { P as C } from "../Profile-BFmE5iar.js";
import { O as z } from "../OddsButton-BoxKPLFW.js";
import { C as H } from "../Cross-jbk27eUQ.js";
import { C as q } from "../Check-CPyIclk1.js";
const W = "320px", b = "600px", S = "1025px", B = "_isVisuallyHidden_1q2zq_51", w = "_tipsWrapper_1q2zq_63", N = "_tips_1q2zq_63", j = "_tableHeadings_1q2zq_67", F = "_tipFooterWrapper_1q2zq_73", v = "_tipFooter_1q2zq_73", D = "_footer_1q2zq_100", I = "_trigger_1q2zq_104", O = "_statusIcon_1q2zq_111", R = "_status_1q2zq_111", T = "_caption_1q2zq_128", P = "_statusColumn_1q2zq_133", i = {
  mobile: W,
  "mobile-wide": "480px",
  tablet: b,
  "tablet-wide": "800px",
  desktop: S,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  isVisuallyHidden: B,
  tipsWrapper: w,
  tips: N,
  tableHeadings: j,
  tipFooterWrapper: F,
  tipFooter: v,
  footer: D,
  trigger: I,
  statusIcon: O,
  status: R,
  caption: T,
  statusColumn: P,
  "status--success": "_status--success_1q2zq_137",
  "status--failure": "_status--failure_1q2zq_144"
}, K = ({
  tipName: x,
  tipImage: d,
  betName: h,
  betDescription: m,
  bookmaker: l,
  stats: o,
  status: s,
  tip: c
}) => {
  const a = () => {
    if (s)
      return /* @__PURE__ */ e(
        "span",
        {
          title: "Bet Status",
          className: r(i.statusIcon, i[`status--${s}`]),
          children: s == "success" ? /* @__PURE__ */ e(q, {}) : /* @__PURE__ */ e(H, {})
        }
      );
  }, u = () => {
    if (!c)
      return;
    const { headingProps: y, sectionProps: g, triggerClass: p, Indicator: f } = _({
      isOpen: !0
    });
    return /* @__PURE__ */ e(t.Footer, { className: i.tipFooterWrapper, children: /* @__PURE__ */ n(t.Row, { className: i.tipFooter, children: [
      /* @__PURE__ */ e(t.Cell, { ...g, children: c }),
      /* @__PURE__ */ n(
        t.Cell,
        {
          ...y,
          justifyContent: "center",
          className: r(p, i.trigger),
          children: [
            "Show More ",
            /* @__PURE__ */ e(f, {})
          ]
        }
      )
    ] }) });
  };
  return /* @__PURE__ */ e(t.Group, { className: i.tipsWrapper, children: /* @__PURE__ */ n(t, { label: "EV", mobileColumns: 3, className: i.tips, children: [
    /* @__PURE__ */ n(t.Caption, { className: i.caption, children: [
      x,
      " ",
      /* @__PURE__ */ e(a, {})
    ] }),
    /* @__PURE__ */ e(t.Head, { className: i.tableHeadings, children: /* @__PURE__ */ n(t.Row, { children: [
      /* @__PURE__ */ e(t.Column, { justifyContent: "center", showDividers: !0, children: l ? "Best Odds" : "Odds" }),
      /* @__PURE__ */ e(t.Column, { justifyContent: "center", showDividers: !0, children: "Stake" }),
      /* @__PURE__ */ e(t.Column, { justifyContent: "center", showDividers: !0, children: "Return" }),
      s && /* @__PURE__ */ e(t.Column, { justifyContent: "center", className: i.status, children: /* @__PURE__ */ e(a, {}) })
    ] }) }),
    /* @__PURE__ */ e(t.Body, { isAdditionalContent: !0, children: /* @__PURE__ */ e(t.Row, { children: /* @__PURE__ */ e(t.Cell, { children: /* @__PURE__ */ e(
      C,
      {
        name: h,
        image: d,
        description: m
      }
    ) }) }) }),
    /* @__PURE__ */ e(t.Body, { className: i.test, children: /* @__PURE__ */ n(t.Row, { children: [
      /* @__PURE__ */ e(t.Cell, { justifyContent: "center", showDividers: !0, children: l ? /* @__PURE__ */ e(z, { ...l, odds: o.odds }) : o.odds }),
      /* @__PURE__ */ e(t.Cell, { justifyContent: "center", showDividers: !0, children: o.stake }),
      /* @__PURE__ */ e(t.Cell, { justifyContent: "center", showDividers: !0, children: o.return }),
      s && /* @__PURE__ */ e(t.Cell, { justifyContent: "center", className: i.status, children: /* @__PURE__ */ e("p", { className: r(i.statusColumn), children: s }) })
    ] }) }),
    c && /* @__PURE__ */ e(u, {})
  ] }) });
};
export {
  K as Tips
};
